// extracted by mini-css-extract-plugin
export default {"latestNewsSection":"Discover_latestNewsSection__KUQH6","heading":"Discover_heading__HKiHH","newsImage":"Discover_newsImage__4kipT","content":"Discover_content__NvTx6"};